import Vue, { PropType } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { GiftEntity } from '@/entities/gift.entity';

@Component<ThanksMessageItemMixin>({})
export default class ThanksMessageItemMixin extends Vue {
  @Prop({ type: Object as PropType<GiftEntity> })
  gift: GiftEntity;
}
